
<!-- Autocomplete Component -->
@if (entry?.base?.display) {
  <form
    [connect]="'payloadStates.' + entry?.formControlAttributes?.connectPath"
    class="question-class"
    [formGroup]="form"
    >
    <mat-form-field appearance="outline">
      <mat-label>{{entry?.formControlAttributes?.label}}</mat-label>
      <input
        #entryRef
        matInput
        [formControlName]="entry?.formControlAttributes?.formControlName"
        type="text"
        [matAutocomplete]="auto"
        placeholder="{{ entry?.inputAttributes?.placeholder }}"
        >
        @if (loadingCities) {
          <mat-progress-spinner diameter="20"></mat-progress-spinner>
        }
        
        <mat-autocomplete #auto="matAutocomplete">
          @for (option of filteredCities | async; track option) {
            <mat-option [value]="option">
              {{option}}
            </mat-option>
          }
        </mat-autocomplete>
        @if (formControls[entry?.formControlAttributes?.formControlName]?.errors?.required) {
          <mat-error>Required</mat-error>
        } @else {
          @if (!showCounter && formControls[entry?.formControlAttributes?.formControlName]?.errors?.maxlength) {
            <mat-error>Character limit: {{formControls[entry?.formControlAttributes?.formControlName]?.errors?.maxlength.requiredLength}} (Current: {{formControls[entry?.formControlAttributes?.formControlName]?.errors?.maxlength.actualLength}})</mat-error>
          }
          @if (!showCounter && formControls[entry?.formControlAttributes?.formControlName]?.errors?.minlength) {
            <mat-error>Character minimum: {{formControls[entry?.formControlAttributes?.formControlName]?.errors?.minlength.requiredLength}} (Current: {{formControls[entry?.formControlAttributes?.formControlName]?.errors?.minlength.actualLength}})</mat-error>
          }
          @if (formControls[entry?.formControlAttributes?.formControlName]?.errors?.pattern) {
            <mat-error>{{getCustomError('pattern') || ("Pattern must match: " + formControls[entry?.formControlAttributes?.formControlName]?.errors?.pattern.requiredPattern)}}</mat-error>
          }
        }
        @if (formControls[entry?.formControlAttributes?.formControlName]?.errors?.maxlength) {
          <mat-error>Character limit: {{formControls[entry?.formControlAttributes?.formControlName]?.errors?.maxlength.requiredLength}} (Current: {{formControls[entry?.formControlAttributes?.formControlName]?.errors?.maxlength.actualLength}})</mat-error>
        }
        @if (formControls[entry?.formControlAttributes?.formControlName]?.errors?.minlength) {
          <mat-error>Character minimum: {{formControls[entry?.formControlAttributes?.formControlName]?.errors?.minlength.requiredLength}} (Current: {{formControls[entry?.formControlAttributes?.formControlName]?.errors?.minlength.actualLength}})</mat-error>
        }
      </mat-form-field>
    </form>
  }